// removed by extract-text-webpack-plugin
module.exports = {"react-django-template":"PriceTrackerSignUpLayout-desktop__react-django-template___-hash--base64-5-"};


/*****************
 ** WEBPACK FOOTER
 ** ./src/layouts/PriceTrackerSignUpLayout/PriceTrackerSignUpLayout.desktop.scss
 ** module id = 956
 ** module chunks = 1
 **/